import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Refresh from "@material-ui/icons/Refresh";
import Phone from "@material-ui/icons/Phone";

import GridContainer from "../Grid/GridContainer.jsx";
import GridItem from "../Grid/GridItem.jsx";
import Card from "../Card/Card.jsx";
import CardBody from "../Card/CardBody.jsx";
import Button from "../CustomButtons/Button.jsx";

import styles from "../../assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

import cardBlog6 from "../../assets/img/info-card-bg.JPG";

class SectionCards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRotate1: "",
            activeRotate2: ""
        };
    }

    componentDidMount() {
        const { classes } = this.props;

        let rotatingCards = document.getElementsByClassName(classes.cardRotate);

        for (let i = 0; i < rotatingCards.length; i++) {
            let rotatingCard = rotatingCards[i];
            let rotatingWrapper = rotatingCard.parentElement;
            let cardWidth = rotatingCard.parentElement.offsetWidth;
            let cardHeight = rotatingCard.children[0].children[0].offsetHeight;
            rotatingWrapper.style.height = cardHeight + "px";
            rotatingWrapper.style["margin-bottom"] = 30 + "px";
            let cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
            let cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
            cardFront.style.height = cardHeight + 35 + "px";
            cardFront.style.width = cardWidth + "px";
            cardBack.style.height = cardHeight + 35 + "px";
            cardBack.style.width = cardWidth + "px";
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <GridContainer>

                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <div
                        className={`${classes.rotatingCardContainer} ${
                            classes.manualRotate
                            } ${this.state.activeRotate2}`}
                    >
                        <Card className={classes.cardRotate}>
                            <div
                                className={`${classes.front} ${
                                    classes.wrapperBackground
                                    }`}
                                style={{ backgroundImage: `url(${cardBlog6})` }}
                            >
                                <CardBody background className={classes.cardBodyRotate}>
                                    <h3 className={classes.cardTitleWhite}>
                                        ¿Deseas una reserva personalizada?
                                    </h3>
                                    <br/>
                                    <div className={classes.textCenter}>
                                        <Button
                                            round
                                            color="danger"
                                            onClick={ () => this.setState({ activeRotate2: classes.activateRotate }) }
                                        >
                                            <Refresh /> Contáctanos
                                        </Button>
                                    </div>
                                </CardBody>
                            </div>
                            <div
                                className={`${classes.back} ${
                                    classes.wrapperBackground
                                    }`}
                                style={{ backgroundImage: `url(${cardBlog6})` }}
                            >
                                <CardBody background className={classes.cardBodyRotate}>
                                    <h5 className={classes.cardTitleWhite}>
                                        <Phone/> (+57) 315 795 1330 - 313 208 9988
                                    </h5>
                                    <h6 className={classes.cardTitleWhite}>
                                        vivamoselcampo@gmail.com
                                    </h6>
                                    <div className={classes.textCenter}>
                                        <a href="https://www.facebook.com/vivamoselcampo/" target="_blank" rel="noopener noreferrer">
                                            <Button round justIcon color="facebook">
                                                <i className="fab fa-facebook-square" />
                                            </Button>
                                        </a>
                                        <a href="https://www.instagram.com/vivamoselcampo/" target="_blank" rel="noopener noreferrer">
                                            <Button round justIcon color="white">
                                                <i className="fab fa-instagram" />
                                            </Button>
                                        </a>
                                        <a href="https://twitter.com/vivamoselcampo" target="_blank" rel="noopener noreferrer">
                                            <Button round justIcon color="twitter">
                                                <i className="fab fa-twitter" />
                                            </Button>
                                        </a>
                                        <Button round justIcon color="success">
                                            <i className="fab fa-whatsapp" />
                                        </Button>
                                        <br />
                                        <br />
                                        <Button
                                            round
                                            color="danger"
                                            onClick={ () => this.setState({ activeRotate2: "" }) }
                                        >
                                            <Refresh /> Girar
                                        </Button>
                                    </div>
                                </CardBody>
                            </div>
                        </Card>
                    </div>
                </GridItem>

            </GridContainer>
        );
    }
}

export default withStyles(styles)(SectionCards);



// WEBPACK FOOTER //
// ./src/components/common/InfoCardVEC.js